/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation CustomerAccountAttachRouteMutation($customerAccountId: ID!, $routeId: ID!) {
  CustomerAccountAttachRoute(customerAccountId: $customerAccountId routeId: $routeId ) {
    message
    status
  }
}
`
